import React from "react";
import Switch from "react-switch";
import "./toogleButton.css";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
const ToogleButton = (props: {
  status1: string;
  status2: string;
  handleChange: () => Promise<void>;
  updateToggleState: boolean;
  className?: string;
  loginUIConfig?:any
}) => {
  const CUR_COMPONENT = "LogInAndChangePassword"
  const { translate } = usePortalTranslation();
  return (
    <>
      <Switch
        className="generic-toggle-button"
        disabled={props.updateToggleState}
        onChange={() => {
          props.handleChange();
        }}
        checked={props.updateToggleState}
        offColor={props?.loginUIConfig ? "#ED1229" : "FFFFFF"}
        onColor={props?.loginUIConfig ? "#ED1229" : "#00C6B1"}
        onHandleColor="#FFFFFF"
        offHandleColor={props?.loginUIConfig ? "FFFFFF" : "#B5B5B5"}
        draggable={true}
        translate={"yes"}
        handleDiameter={27}
        uncheckedIcon={
          <>
            <div style={props?.loginUIConfig ? { color:"white" } : {}} 
              className={`login-toggle-unchecked-icon-status ${props.className}`}
            >
              {translate(TranslationEnum.login_and_change_password,props.status1)}
            </div>
          </>
        }
        checkedIcon={
          <>
            <div style={props?.loginUIConfig ? { color:"white" } : {}} className="login-toggle-checked-icon-status">
            {translate(TranslationEnum.login_and_change_password,props.status2)}
            </div>
          </>
        }
        boxShadow="-5px 3px 20px #00000026"
        height={36}
        width={106}
      />
    </>
  );
};

export default ToogleButton;
